import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, InjectedFormProps } from 'redux-form';
import InputGroup from '../../Forms/InputGroup';
import Checkbox from '../../Forms/Checkbox';
import approve from 'approvejs';
import { getTranslationKey } from '../../../modules/utils/helpers';

interface FieldConfig {
  type: string;
  placeholder: string;
  rules: any;
}

interface FormFields {
  [key: string]: FieldConfig;
}

const getFields = (): FormFields => ({
  first_name: {
    type: 'text',
    placeholder: getTranslationKey('firstname') + ' *',
    rules: {
      required: { message: getTranslationKey('requiredFirstnameInput') }
    }
  },
  last_name: {
    type: 'text',
    placeholder: getTranslationKey('lastname') + ' *',
    rules: {
      required: { message: getTranslationKey('requiredLastnameInput') }
    }
  },
  email: {
    type: 'text',
    placeholder: getTranslationKey('emailPlaceholder') + ' *',
    rules: {
      email: {
        message: getTranslationKey('requiredEMailInput')
      }
    }
  },
  phone_no: {
    type: 'text',
    placeholder: getTranslationKey('phone_no'),
    rules: {}
  },
  zipcode: {
    type: 'text',
    placeholder: getTranslationKey('zipcode'),
    rules: {}
  },
  message: {
    type: 'textarea',
    rules: {
      ignoreNull: true,
      min: 0,
      max: {
        max: 500,
        message: getTranslationKey('maxXCharacters').replace('$X$', '500')
      }
    },
    placeholder: getTranslationKey('message')
  }
});

interface LeadFormOwnProps {
  optin?: boolean;
  saveLead: (values: any) => void;
  phone_no_required?: boolean;
}

type LeadFormProps = LeadFormOwnProps & InjectedFormProps<{}, LeadFormOwnProps>;

const LeadForm: React.FC<LeadFormProps> = ({
  invalid,
  submitting,
  pristine,
  handleSubmit,
  optin,
  saveLead,
  phone_no_required
}) => (
  <form onSubmit={handleSubmit(saveLead)}>
    <div className="row">
      <div className="col">
        {Object.keys(getFields()).map((fieldKey, index) => {
          const field = getFields()[fieldKey];

          if (fieldKey === 'phone_no' && phone_no_required) {
            field.rules = {
              required: {
                message: getTranslationKey('requiredPhoneNumberInput')
              }
            };
            if (field.placeholder && !field.placeholder.includes('*')) field.placeholder += ' *';
          }

          return <Field component={InputGroup} key={index} name={fieldKey} field={field} />;
        })}
        <div className="booking-optin-wrapper">
          <Field
            component={Checkbox}
            name="optin"
            field={{
              text: getTranslationKey('emailContactAllowed'),
              checked: optin
            }}
          />
        </div>
        <button
          className="btn btn-success w-100-p btn-booking"
          disabled={invalid || submitting || pristine}
          type="submit"
        >
          {getTranslationKey('nextStep')}
        </button>
      </div>
    </div>
  </form>
);

function validate(values: any) {
  const errors: any = {};

  Object.keys(getFields()).forEach((fieldKey) => {
    const result = approve.value(values[fieldKey], getFields()[fieldKey].rules);
    if (result.errors.length > 0) {
      errors[fieldKey] = result.errors;
    }
  });

  return errors;
}

const LeadFormWrapped = reduxForm<{}, LeadFormOwnProps>({
  form: 'bookingLeadForm',
  validate,
  destroyOnUnmount: false
})(LeadForm);

const selector = formValueSelector('bookingLeadForm');

const mapStateToProps = (state: any) => ({
  optin: selector(state, 'optin')
});

export default connect(mapStateToProps)(LeadFormWrapped);
